import React from 'react';

import { AppType } from '../../../../store/store';
import css from '../SetPlan.module.scss';
import { Plan } from '../index';
import Button from '../../../../components/UI/Button';
import {
  infinityChoosePlanChecklist,
  maxChoosePlanChecklist,
  standardChoosePlanChecklist
} from '../ChecklistsAndContent/checklistContent';
import { PlanPrices } from '../../../../utils/prices';

interface Props {
  loading: boolean;
  plan: string;
  plans: PlanPrices;
  onInfoClicked: (plan: Plan) => void;
  onUpgradeClicked: (plan: Plan) => void;
  onSkip: () => void;
  analytics: any;
}

const PlanContainer = ({
  loading,
  plan,
  plans,
  onInfoClicked,
  onUpgradeClicked,
  onSkip,
  analytics
}: Props) => {
  const choosePlan = () => {
    analytics.trackEvent('Registration Invest Plan Action', {
      eventProps: {
        plan: Plan[plan],
        price: plans[plan],
        skipped: false
      }
    });
    if (plan === 'standard') {
      onSkip();
    } else {
      onUpgradeClicked(Plan[plan]);
    }
  };

  const planDataByType = {
    standard: {
      header: 'Greenlight Core',
      checklist: standardChoosePlanChecklist,
      badge: ''
    },
    max: {
      header: 'Greenlight Max',
      checklist: maxChoosePlanChecklist,
      badge: 'Recommended'
    },
    infinity: {
      header: 'Greenlight Infinity',
      checklist: infinityChoosePlanChecklist,
      badge: 'Best Value'
    }
  };

  return (
    <div className={css.planContainer}>
      {planDataByType[plan].badge && (
        <div className={css.bestValue} data-e2e="plan-badge">
          <p>{planDataByType[plan].badge}</p>
        </div>
      )}
      <div className={css.plan}>
        {plan !== 'standard' && (
          <img
            src="../../../static/info-icon-green.svg"
            className={css.planOptionInfo}
            onClick={() => onInfoClicked(Plan[plan])}
            data-testid={`${plan}-info`}
          />
        )}
        <h3 className={css.investOptionHeader}>
          {planDataByType[plan].header}
        </h3>
        <p className={css.investOptionPrice} data-e2e={`${plan}-price`}>
          ${plans[plan]}/month after trial
        </p>
        <div className={css.checklistRedesign}>
          {plan !== 'standard' && (
            <p className={css.investOptionSubheader}>
              All the core tools plus:
            </p>
          )}
          {planDataByType[plan].checklist}
        </div>
        <Button
          text="Select this plan"
          loading={loading}
          onClick={choosePlan}
          data-e2e={`upgrade-${plan}`}
        />
      </div>
    </div>
  );
};

export default PlanContainer;
